import { MinimumStation, Station } from '@mi-front/core';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Chip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import { youtubeNativeStationTooltipMessage } from './station-messages';

interface YoutubeNativeStationChipProps {
  station?: Station | MinimumStation | null;
  sx?: SxProps<Theme>;
}

function isYoutubeNativeStation(station: Station | MinimumStation): station is Station {
  return 'youtubeNative' in station && station.youtubeNative;
}

/**
 * Renders a YouTube-native station chip when the station has the youtubeNative flag enabled.
 */
export function YoutubeNativeStationChip({ station, sx }: YoutubeNativeStationChipProps) {
  const { $t } = useIntl();

  if (!station || !isYoutubeNativeStation(station)) {
    return null;
  }

  return (
    <Chip
      label={$t(youtubeNativeStationTooltipMessage)}
      size="small"
      variant="outlined"
      icon={<YouTubeIcon />}
      sx={
        [
          {
            fontWeight: 400,
          },
          sx,
        ] as SxProps<Theme>
      }
    />
  );
}
